import BlockIcon from "@mui/icons-material/Block";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import UndoIcon from "@mui/icons-material/Undo";

export const TOAST_CONFIG = {
  position: "bottom-right" as const,
  duration: 4000,
};

export const NAVIGATION_ROUTES = {
  ACCEPTED_REQUESTS: "/admin/drivers/drivers-table/accepted-requests",
  REJECTED_REQUESTS: "/admin/drivers/drivers-table/refused-requests",
  WAITING_REQUESTS: "/admin/drivers/drivers-table/waiting-requests",
  DISABLED_DRIVERS: "/admin/drivers/drivers-table/disabled-drivers",
  GO_BACK: -1,
} as const;

export const SUCCESS_MESSAGES = {
  CONFIRM: "common.success",
  REJECT: "common.reject.success",
  CANCEL_REJECT: "common.cancelReject.success",
  DISABLE: "common.disable.success",
  ENABLE: "common.enable.success",
} as const;

export enum BUTTON_COLORS {
  INHERIT = "inherit",
  PRIMARY = "primary",
  SECONDARY = "secondary",
  SUCCESS = "success",
  ERROR = "error",
  INFO = "info",
  WARNING = "warning",
}

export const ERROR_MESSAGES = {
  GENERIC: "common.error.generic",
  REJECT: "common.reject.error",
} as const;

export const DRIVER_ACTIONS = {
  CONFIRM: {
    title: "common.confirmation-accept-title",
    buttonText: "common.accept",
    confirmation: "common.confirmation-accept",
    icon: CheckCircleIcon,
  },
  REJECT: {
    title: "common.confirmation-reject-title",
    buttonText: "common.reject",
    confirmation: "common.confirmation-reject",
    icon: CancelIcon,
  },
  CANCEL_REJECT: {
    title: "common.confirmation-cancelReject-title",
    buttonText: "common.cancelReject",
    confirmation: "common.confirmation-cancelReject",
    icon: UndoIcon,
  },
  DISABLE: {
    title: "common.confirmation-disable-title",
    buttonText: "common.disable",
    confirmation: "common.confirmation-disable",
    icon: BlockIcon,
  },
  ENABLE: {
    title: "common.confirmation-enable-title",
    buttonText: "common.enable",
    confirmation: "common.confirmation-enable",
    icon: LockOpenIcon,
  },
};
